import React from "react";
import { highlightText } from "../../util/highlightText";
import { ITopSearchQueryProps } from "../../types/suggestion-items";
import { ITelemetryData } from "../../types/telemetry";
import { sendTelemetryData } from "../../util/telemetry";
import { useNavigationContext } from "../common/contexts";

const TopSearchQuery = (props: ITopSearchQueryProps) => {
    const { handleMouseSelect, handleMouseDeselect, handleTouched } = useNavigationContext();

    const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        handleTouched(props.topSearchQuery.navIndex);
        recordTopSearchQueryUsed();
        window.location.href = props.topSearchQuery.target;
    };

    const recordTopSearchQueryUsed = () => {
        const data: ITelemetryData = {
            correlationId: props.searchInfo.pageViewLogDataId,
            culture: props.searchInfo.culture,
            portal: props.searchInfo.portal,
            searchTerm: props.searchInfo.searchTerm,
            shortLink: "",
            suggestion: props.topSearchQuery.value,
            contentType: props.topSearchQuery.type
        };
        sendTelemetryData(data, props.searchInfo.trackingEndpoint);
    };

    return props.topSearchQuery.isHeadline ? (
        <li
            className={"top-search-query-text not-selectable"}
            key={props.topSearchQuery.navIndex}
            ref={props.setRef}
        >
            {props.topSearchQuery.value}
        </li>
    ) : (
        <li
            className={"top-search-query-item"}
            key={props.topSearchQuery.navIndex}
            ref={props.setRef}
            onMouseEnter={() => handleMouseSelect(props.topSearchQuery.navIndex)}
            onMouseLeave={handleMouseDeselect}
        >
            <a
                href={props.topSearchQuery.target}
                onClick={handleClick}
                data-testid={`ssw-top-search-${props.topSearchQuery.anchorIndex}`}
                data-semantic-id={`ssw-top-search-${props.topSearchQuery.anchorIndex}`}
            >
                {highlightText(props.topSearchQuery.value, props.searchInfo.searchTerm)}
            </a>
        </li>
    );
};

export default TopSearchQuery;
